var _rect, _rect2, _path, _rect3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterstitialIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 76,
    viewBox: "0 0 140 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 76,
    fill: "#EFEEEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 8.5,
    width: 75,
    height: 59,
    rx: 3.5,
    fill: "#DAD8DA",
    stroke: "#6E28FC",
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.1844 37.7112L67.2344 32.5799C67.0125 32.3893 66.6875 32.5612 66.6875 32.869V43.1315C66.6875 43.4393 67.0125 43.6112 67.2344 43.4205L73.1844 38.2893C73.3547 38.1424 73.3547 37.858 73.1844 37.7112Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 12,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#6E28FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4046 18L100.455 15.5555C100.49 15.5148 100.461 15.4531 100.408 15.4531H99.7843C99.7476 15.4531 99.7124 15.4695 99.6882 15.4977L97.9968 17.5141L96.3054 15.4977C96.282 15.4695 96.2468 15.4531 96.2093 15.4531H95.5859C95.5328 15.4531 95.5038 15.5148 95.5382 15.5555L97.589 18L95.5382 20.4445C95.5305 20.4536 95.5256 20.4647 95.524 20.4764C95.5224 20.4882 95.5242 20.5002 95.5292 20.511C95.5342 20.5218 95.5423 20.5309 95.5523 20.5372C95.5623 20.5436 95.574 20.5469 95.5859 20.5469H96.2093C96.246 20.5469 96.2812 20.5305 96.3054 20.5023L97.9968 18.4859L99.6882 20.5023C99.7117 20.5305 99.7468 20.5469 99.7843 20.5469H100.408C100.461 20.5469 100.49 20.4852 100.455 20.4445L98.4046 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterstitialIcon);
export default __webpack_public_path__ + "static/media/interstitial-icon.6a71dd6bc33695f1f3296bd611c98f43.svg";
export { ForwardRef as ReactComponent };